// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__OdaZ6","name":"styles_name__y7Fz7","description":"styles_description__6JtIa","skeleton-animation":"styles_skeleton-animation__fEcW5"};